import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSubDomain, tenantByDomain } from '../utils/AuthUtils.js';
import { setTenant, setKeycloakSettings } from './authSlice.js';
import { factory } from '../../../utils/apiThunkFactory.js';




export const login = factory.post('auth/login', '/api/auth/login');
//TODO: implement logout api whith update chairs status
export const checkValidity = factory.get('auth/checkValidity', '/api/guest/check/:code');
export const guestLoginDemo = factory.post('auth/guestLoginDemo', '/api/guest/demo/login');
export const getBookingPublicById = factory.get('auth/getBookingPublicById', '/api/guest/public/:bookingId');
export const guestLogin = factory.post('auth/guestLogin', '/api/guest/login');
export const getLivekitUrl = factory.get('auth/getLivekitUrl', '/api/tenants/livekit-url/:tenantId');
export const getTenantByDomain = factory.get('auth/getTenantByDomain', '/api/tenants/domain/:subDomain');
export const logoutGuestUser = factory.post('auth/logoutGuestUser', '/api/guest/logout');
export const getUserPermissions = factory.get('permissions/getByUser', '/api/auth/getByUser');
export const getTenantSettings = factory.get('auth/getTenantSettings', '/api/tenants/by-domain/:subDomain/public');
export const getBookingPublicSimpleById = factory.get('auth/getBookingPublicSimpleById', '/api/guest/public-simple/:bookingId');
export const getNextBookingOccurrence = factory.get('auth/getNextBookingOccurrence', '/api/guest/next/:id');
export const decodeMeetingToken = factory.get("auth/decodeMeetingToken", "/api/guest/decode-meeting-token?m=:token");

export const uploadImage = factory.post("auth/uploadImage", "/api/guest/upload-photo");
export const deletePhoto = factory.post("auth/deletePhoto", "/api/guest/delete-photo");
export const updateUserIsFirstLogin  = factory.post("auth/updateUserIsFirstLogin", "/api/users/update_is_first_login");
export const addGuestDemo =  factory.post("inviteModal/addGuest", '/api/guest/demo/addDemo');

export const getGuestDemoLinkEncryptedSetting = factory.get('auth/getGuestDemoLinkEncryptedSetting', '/api/tenants/guest-demo-link-encrypted/:tenantId');
export const getGuestDemoLinkValidationSetting = factory.get('auth/getGuestDemoLinkValidationSetting', '/api/tenants/guest-demo-link-validated/:tenantId');
export const isParticipantBanned = factory.post('auth/isParticipantBanned', '/api/guest/is_participant_banned');

